module.exports = __webpack_public_path__ + "img/طبیعی.b56f48d1.png";